import React, { useEffect, useState, Text } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link, useHistory,
  BrowserRouter as Router,
  Switch,
  Route,
  useParams,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { setCidade, getIdCidadeEcrie, getTotem } from '../../api/apiFactory';
import {
  fetchLimparCookie, fetchNomeCidade, fetchEvento, fetchTransporteColetivo,
} from '../../api/endpoints';
import { definirCidade, fetchConfiguracoesCidade, selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao } from '../../app/slices/loginSlice';
import { resetarModais, selectModal } from '../../app/slices/modalSlice';
import imagemNaoDisponivel from '../../assets/images/imagemindisponivel.png';
import AppHeader from '../../components/AppHeader/AppHeader';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import Carregar from '../../components/Carregar/Carregar';
import Botao from '../../components/Botao/Botao';
import ModalLogin from '../../components/ModalLogin/ModalLogin';
import CardTransporte from '../../components/CardTransporte/CardTransporte';
import { espacamento } from '../../styles/constants/sizes';
import {
  AppBody, AppFragment, Container, Grid, Interno, Linha, Titulo,
} from '../../styles/base';

const IniciarTransporteColetivo = () => {
  const dadosModal = useSelector(selectModal);
  const dadosCidade = useSelector(selectCidade);
  const [transporte, setTransporte] = useState();

  const dispatch = useDispatch();
  const history = useHistory();
  window.onload = () => {
    dispatch(resetarModais());
  };

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  if (cookieId) {
    const escolherCidadeCookie = async (Id, Campo) => {
      setCidade({ Id, Campo });
      dispatch(definirCidade({
        idCidade: Id,
        nomeCidade: Campo,
      }));
      await fetchLimparCookie();
      await dispatch(fetchConfiguracoesCidade());
    };

    dispatch(desfazerConexao());
    fetchNomeCidade(cookieId).then((nomeCidade) => escolherCidadeCookie(cookieId, nomeCidade));
  }

  const { id } = useParams();

  useEffect(() => {
    fetchTransporteColetivo(parseFloat(id)).then((response) => { setTransporte(response); });
    if (!(getIdCidadeEcrie() > 0)) {
      history.push('/');
    }
  }, []);

  if (!transporte) {
    return (
      <Carregar />
    );
  }

  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
      {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
      {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
      <AppHeader />
      <AppBody totem={getTotem() === 'true'} desfoque={dadosModal.desfoque} className="controle-fundo">
        <Container totem={getTotem() === 'true'}>
          <Titulo totem={getTotem() === 'true'}>
            Transporte Coletivo -
            {' '}
            {dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade}
          </Titulo>
          <Botao
            link
            label="Voltar"
            style={{ marginRight: espacamento.pequeno, display: 'block', marginBottom: espacamento.medio }}
            onClick={() => history.push('/transportes')}
          />
          <Interno>
            <Linha>
              {transporte && !transporte.Message && (
                <CardTransporte
                  diaSemana={transporte.DiaSemana}
                  empresa={transporte.Empresa}
                  enderecoAte={transporte.EnderecoAte}
                  enderecoDe={transporte.EnderecoDe}
                  horario={transporte.Horario}
                  itinerario={transporte.Itinerario}
                  linha={transporte.Linha}
                  observacao={transporte.Observacao}
                />
              )}
              {transporte && transporte.Message && transporte.Message === 'Nenhum registro foi encontrado.' && (
              <p>Nenhum registro foi encontrado.</p>
              )}
            </Linha>
          </Interno>
        </Container>
      </AppBody>
    </AppFragment>
  );
};

export default IniciarTransporteColetivo;
